import React from "react";
import { useParams } from "react-router-dom";
import { isNetworkId, networkNames } from "../AmendTariffs/networkConfig";
import PredictInstantBreadcrumb from "./PredictInstantBreadcrumb";
export default () => {
    const { networkId = "" } = useParams();
    if (!isNetworkId(networkId)) {
        return null;
    }
    return (React.createElement(PredictInstantBreadcrumb, { segments: ["Amend Tariffs", networkNames[networkId]], embedded: true }));
};
